document.querySelectorAll('.inline-menu__nav').forEach(function(nav) {
	var isDown = false;
	var lastX;
	var moved = false;
	var wrapper = nav.closest('.inline-menu__wrapper');

	// Arrow scroll state
	function updateArrows() {
		if (!wrapper) return;
		var atLeft = nav.scrollLeft <= 1;
		var atRight = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1;
		wrapper.classList.toggle('can-scroll-left', !atLeft);
		wrapper.classList.toggle('can-scroll-right', !atRight);
	}

	nav.addEventListener('scroll', updateArrows);
	window.addEventListener('resize', updateArrows);
	// Initial check after paint
	requestAnimationFrame(updateArrows);

	// Arrow buttons click
	if (wrapper) {
		var btnLeft = wrapper.querySelector('.inline-menu__arrow--left');
		var btnRight = wrapper.querySelector('.inline-menu__arrow--right');
		if (btnLeft) btnLeft.addEventListener('click', function() {
			nav.scrollBy({ left: -200, behavior: 'smooth' });
		});
		if (btnRight) btnRight.addEventListener('click', function() {
			nav.scrollBy({ left: 200, behavior: 'smooth' });
		});
	}

	// Drag to scroll
	nav.addEventListener('dragstart', function(e) {
		e.preventDefault();
	});

	nav.addEventListener('mousedown', function(e) {
		isDown = true;
		moved = false;
		lastX = e.pageX;
		nav.style.cursor = 'grabbing';
		nav.style.userSelect = 'none';
	});

	document.addEventListener('mouseup', function() {
		isDown = false;
		nav.style.cursor = '';
		nav.style.userSelect = '';
	});

	document.addEventListener('mousemove', function(e) {
		if (!isDown) return;
		var delta = lastX - e.pageX;
		if (Math.abs(delta) > 2) moved = true;
		nav.scrollLeft += delta;
		lastX = e.pageX;
	});

	nav.addEventListener('click', function(e) {
		if (moved) e.preventDefault();
	}, true);
});
